export default "__VITE_ASSET__DfpRbnbw__"